export default Object.freeze({
  // 운영관리 > SMS 관리 > 자동SMS 발송내역 조회
  NOTICE_HIGHLIGHT1: 'ⓘ NHN Cloud를 통한 SMS 발송 기능은 2023년 1월 2일 오전 9시 종료되었으며, 1월 2일부로 신규 발송은 불가합니다. ',
  NOTICE_HIGHLIGHT2: 'ⓘ 단, NHN Cloud를 통해 자동 SMS 발송하신 내역은 서비스 종료 이후에도 일정 기간 조회 가능하도록 제공될 예정입니다. (2023년 3월 종료 예정)',
  NOTICE_HIGHLIGHT3: 'ⓘ 서비스 종료 이후 SMS 포인트를 사용하여 신규로 발송된 내역은 \'운영관리 > SMS 관리(포인트) > SMS 발송내역 조회\' 메뉴에서 확인하실 수 있습니다. ',
  NOTICE1: 'ⓘ 쇼핑몰에서 회원에게 발송한 자동SMS 중 무료발송 항목에 대한 발송내역을 조회할 수 있습니다.',
  NOTICE2: 'ⓘ 자동SMS 유료항목에 대한 발송내역은 수동SMS 발송내역과 함께 NHN Cloud에서 조회하실 수 있습니다.',
  NOTICE3: 'ⓘ 발송내역은 시작 일시 달의 일수만큼 조회 가능합니다.',
  NOTICE4: 'Ⓘ 요청ID 클릭 시, 수신자를 조회할 수 있습니다.',
  NOTICE5: 'Ⓘ 발송된 SMS의 상세내용은 내용 클릭 시 확인이 가능합니다.',
  DATE_TTL: '발송요청 일시',
  MESSAGE_TYPE: '발송 유형',
  LAYER_TTL: 'SMS 발송내용 상세보기',
  RECIPIENT_TTL: 'SMS 수신자 조회',
  REQUEST_ID: '요청ID',
  SMS_TYPE: 'SMS 유형',
  SEND_TYPE: '발송 유형',
  RECIPIENT_NO: '수신번호',
  STATUS_NAME: '발송요청 상태',
  RESULT_CODE: '수신결과 상태',
  RESULT_DATE: '단말기수신일시',
  REQUEST__ID: '요청 ID',
  CONTENTS: '내용',
  SEND: '즉시발송',
  NO_DATA: '검색 결과가 없습니다.',
})